import { gql } from '@apollo/client';

const GET_USER = gql`
  query GetUser {
    user {
      accountId
      firstName
      lastName
      fullName
      email
      organizationName
      barNumber
      phoneNumber
      termsConditionsLastAcceptance
      isFirmAdmin
      engagementLevel
      productTypesPurchased
      productPracticeAreasPurchased
      secondaryPracticeAreas {
        selected
      }
      organizationType {
        value
      }
      userRole {
        value
      }
      needsEmailUpdate
      needsEmailUpdateReason
      cleComplianceDeadline {
        complianceGroupId
        periodStartDate
        periodEndDate
        reportingDate
      }
      complianceGroupOverrideId
    }
    firm {
      id
      name
    }
  }
`;

export default GET_USER;
